export const SET_FETCHING = "MERCHANDISING/SET_FETCHING";
export const GET_COLLECTION = "MERCHANDISING/GET_COLLECTION";
export const SET_SNACKBAR = "MERCHANDISING/SET_SNACKBAR";
export const SET_COPYING = "MERCHANDISING/SET_COPYING";
export const SET_ALL_PUBLISH_TENTPOLES = "MERCHANDISING/SET_ALL_PUBLISH_TENTPOLES";